/**
 * @generated SignedSource<<278c25932936a2182632e6efb43ccc5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedPrintDetailsLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetails_item">;
  readonly " $fragmentType": "PdpRespSharedPrintDetailsLazy_item";
};
export type PdpRespSharedPrintDetailsLazy_item$key = {
  readonly " $data"?: PdpRespSharedPrintDetailsLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetailsLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedPrintDetailsLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "35c06f1cf4e589dae50bde8ae29b4902";

export default node;
